import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import { DURATION } from "../../../constants";

// Shared by every timeout notification: the same message is shown only once per window,
// so several listeners timing out together do not stack identical error toasts.
const LAST_SHOWN_BY_MESSAGE = new Map();
const TOAST_DEDUPLICATION_WINDOW_MS = 15 * 1000;

export const timeoutCallbackFactory = (
  message = "Problems might have been occurred with booking, please reload the page to see if the changes has been applied."
) => {
  return () => {
    const now = Date.now();
    const lastShown = LAST_SHOWN_BY_MESSAGE.get(message) || 0;

    if (now - lastShown < TOAST_DEDUPLICATION_WINDOW_MS) {
      return;
    }

    LAST_SHOWN_BY_MESSAGE.set(message, now);

    snackbarService.show({
      message: message,
      type: "error",
      duration: DURATION,
    });
  };
};
